module.exports = __webpack_public_path__ + "img/License 2.svg";